'use client';

import { c as _c } from "react/compiler-runtime";
import { DialogContextProvider } from '@morpho-org/ui-v6/contexts';
import { memo, type PropsWithChildren } from 'react';
import DialogOnMountContextProvider from '../DialogOnMount/DialogOnMount.context';
import DialogOnMountContextDataProvider from '../DialogOnMountData/DialogOnMountData.context';
export type InterfaceDialogProviderProps = PropsWithChildren;
const InterfaceDialogProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <DialogOnMountContextDataProvider><DialogContextProvider><DialogOnMountContextProvider>{children}</DialogOnMountContextProvider></DialogContextProvider></DialogOnMountContextDataProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default memo(InterfaceDialogProvider);